import { useEffect } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';

import { sessionState } from '@chainlit/react-client';

import { roeFormState, ROEFormPayload } from '@/state/project';

export default function ROEFormListener() {
  const session = useRecoilValue(sessionState);
  const setPayload = useSetRecoilState(roeFormState);

  useEffect(() => {
    const socket = session?.socket;
    if (!socket) return;
    const handler = (payload: ROEFormPayload) => {
      setPayload(payload);
    };
    const dismissHandler = () => {
      setPayload(null);
    };
    socket.on('ask_roe_form', handler);
    socket.on('dismiss_roe_form', dismissHandler);
    return () => {
      socket.off('ask_roe_form', handler);
      socket.off('dismiss_roe_form', dismissHandler);
    };
  }, [session?.socket, setPayload]);

  return null;
}
